import { Modal } from 'react-bootstrap';
import { KTSVG } from '../../../../_metronic/helpers/components/KTSVG';

interface Props extends React.ComponentProps<typeof Modal> {
  imagePath: string;
  show: boolean;
  onHide: () => void;
  imageAlt?: string;
  value?: React.ReactNode;
}

export default function ImageModal({ imagePath, show, onHide, imageAlt, value, ...props }: Props) {
  return (
    <Modal
      id='kt_modal_buyer_picture'
      aria-hidden='true'
      tabIndex={-1}
      size='xl'
      contentClassName='bg-opacity-0 w-auto mx-auto'
      centered
      show={show}
      onHide={onHide}
      {...props}
    >
      <div className='modal-body p-0'>
        <div
          className='btn btn-icon btn-sm btn-dark bg-dark bg-opacity-75 position-absolute start-100 translate-middle'
          onClick={onHide}
        >
          <KTSVG className='svg-icon-2' path='/media/icons/duotune/arrows/arr061.svg' />
        </div>
        <img
          src={imagePath}
          alt={imageAlt}
          style={{ objectFit: 'contain', maxWidth: '100%', maxHeight: '80vh' }}
        />
        {value}
      </div>
    </Modal>
  );
}
